export const GET_LESSON_BY_ID = 'lesson/GET_LESSON_BY_ID';
export const UPDATE_LESSON_BY_ID = 'lesson/UPDATE_LESSON_BY_ID';
export const REMOVE_LESSON_BY_ID = 'lesson/REMOVE_LESSON_BY_ID';
export const UPDATE_LESSON_STATUS_BY_ID = 'lesson/UPDATE_LESSON_STATUS_BY_ID';
